var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "-2 -2 28 28",
    fill: "#697582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,0h-23C0.224,0,0,0.224,0,0.5v23C0,23.776,0.224,24,0.5,24h23c0.276,0,0.5-0.224,0.5-0.5v-23 C24,0.224,23.776,0,23.5,0z M23,1v16h-0.691l-3.398-6.795c-0.362-0.727-1.063-1.176-1.876-1.203 c-0.821-0.031-1.542,0.376-1.952,1.078l-2.638,4.522C11.668,13.664,10.007,12,8,12c-2.465,0-4.311,3.801-4.832,5H1V1H23z M21.191,17H4.268C4.994,15.469,6.484,13,8,13c2.199,0,4.065,2.75,4.084,2.778c0.095,0.143,0.246,0.21,0.431,0.222 c0.172-0.005,0.33-0.099,0.417-0.248l3.015-5.168c0.221-0.379,0.618-0.6,1.055-0.582c0.439,0.014,0.819,0.257,1.014,0.649 L21.191,17z M1,23v-5h22v5H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,9h3c1.654,0,3-1.346,3-3s-1.346-3-3-3C8.203,3,7.087,3.819,6.675,5.009C5.519,4.896,4.5,5.834,4.5,7    C4.5,8.103,5.397,9,6.5,9z M6.49,6c0.124,0,0.249,0.024,0.37,0.071C7.002,6.124,7.159,6.113,7.29,6.038    C7.42,5.962,7.51,5.833,7.534,5.684C7.69,4.708,8.517,4,9.5,4c1.103,0,2,0.897,2,2s-0.897,2-2,2h-3c-0.551,0-1-0.449-1-1    S5.944,6,6.49,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.72f16487690cf553ea5c3f2d4a427cb8.svg";
export { ForwardRef as ReactComponent };